export const dataSource = {
  "live": "โหมดสด",
  "mock": "โหมดจำลอง",
  "liveTooltip": "ข้อมูลถูกดึงมาจากฐานข้อมูล Supabase จริง",
  "mockTooltip": "กำลังแสดงข้อมูลจำลอง ไม่มีการบันทึกการเปลี่ยนแปลง"
};
